import { StepLayout } from '../StepLayout';
import { AnimatedWordExample } from '../AnimatedWordExample';
import { TUTORIAL_LETTERS } from '../constants';
import { ru } from '@/i18n/ru';

export function Step1Intro() {
  return (
    <StepLayout title={ru.onboarding.step1.title}>
      <p>{ru.onboarding.step1.body}</p>
      <AnimatedWordExample word="крот" letters={TUTORIAL_LETTERS} showScore={false} />
      <p>{ru.onboarding.step1.caption}</p>
    </StepLayout>
  );
}
